import { AxiosInstance } from '../../../utilities/requestClient';
import type { CryptoOverviewPageModel } from './types';

export const CRYPTO_BREAKDOWN_PATH = 'get_crypto_breakdown';
export const CRYPTO_EXPORT_PATH = 'get_crypto_export';

/** GET /get_crypto_breakdown/<selected_position_date> — manco crypto overview. */
export const getCryptoBreakdownURL = (positionDate: string) =>
  `${CRYPTO_BREAKDOWN_PATH}/${positionDate}`;

export const getCryptoExportURL = (positionDate: string) =>
  `${CRYPTO_EXPORT_PATH}/${positionDate}`;

export const getCryptoExportFileName = (positionDate: string) =>
  `Crypto_export-${positionDate}.xlsx`;

export const appendCryptoExportQueryParams = (
  url: string,
  raptorPlatformId?: string,
) => {
  if (!raptorPlatformId) {
    return url;
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}raptor_platform_id=${raptorPlatformId}`;
};

export const getCryptoExportDownloadUrl = (
  positionDate: string,
  raptorPlatformId?: string,
) =>
  appendCryptoExportQueryParams(
    getCryptoExportURL(positionDate),
    raptorPlatformId,
  );

export const getCryptoBreakdown = async (
  positionDate: string,
): Promise<CryptoOverviewPageModel> => {
  const { data } = await AxiosInstance.get<CryptoOverviewPageModel>(
    getCryptoBreakdownURL(positionDate),
  );
  return data;
};

/** GET /get_crypto_export/<selected_position_date> — xlsx download. */
export const getCryptoExport = async (
  positionDate: string,
  raptorPlatformId?: string,
): Promise<Blob> => {
  const { data } = await AxiosInstance.get<Blob>(
    getCryptoExportDownloadUrl(positionDate, raptorPlatformId),
    { responseType: 'blob' },
  );
  return data;
};
